import { useTranslation } from "react-i18next";

/**
 * The two name cells of a booking table: "Patient Name" and "Child Name".
 *
 * Same split the doctor app's Appointments / Dashboard tables make for a child consultation:
 *  - Patient Name is about the ADULT patient. It shows the name only (no patient photo). On a child
 *    booking it carries nothing that belongs to the child, just a muted "No Patient" (a blank cell
 *    reads as missing data).
 *  - Child Name shows the child's name, and a muted "-" otherwise. No picture or icon, matching
 *    the doctor app.
 *
 * Shared by every dashboard and order-management table so they cannot disagree about who the
 * patient is. Render the CONTENT of a `<td>`; the caller owns the cell.
 *
 * `childName` doubles as the child-row flag: it is empty for a self booking (see
 * `composeBookingChildName`). A child booking whose snapshot somehow has no name falls back to
 * showing the account holder, rather than "No Patient" + "-", which would hide everyone.
 */
const row = { display: "flex", alignItems: "center", gap: "8px" };
const muted = { color: "#9ca3af" };

export function BookingPatientNameCell({ childName, name }) {
  const { t } = useTranslation();
  if (childName) {
    return (
      <div style={row}>
        <span style={muted}>{t("childBooking.noPatient", "No Patient")}</span>
      </div>
    );
  }
  return (
    <div style={row}>
      <span>{name}</span>
    </div>
  );
}

export function BookingChildNameCell({ childName }) {
  if (childName) {
    return (
      <div style={row}>
        <span>{childName}</span>
      </div>
    );
  }
  return (
    <div style={row}>
      <span style={muted}>-</span>
    </div>
  );
}
